import { denormalize } from 'normalizr';
import { sort } from 'ramda';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';

import { createAlphabeticalComparator } from 'utils/helpers';

import { types } from './actions';
import { discountDefSchema } from './entities';

const initialState = {
  discountDefIds: [],
  entities: {},
  isCreating: false,
  isCreateModalOpen: false,
};

const entitiesReducer = createEntitiesReducer(
  ['discountDefs'],
  [types.CREATE_DISCOUNT_SUCCESS, types.RECEIVE_DISCOUNT_DEFINITIONS],
);

const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.CREATE_DISCOUNT_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case types.CREATE_DISCOUNT_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case types.CREATE_DISCOUNT_SUCCESS:
      return {
        ...state,
        discountDefIds: [...state.discountDefIds, payload.result],
        isCreating: false,
        isCreateModalOpen: false,
      };
    case types.NEW_DISCOUNT_MODAL_CLOSE:
      return {
        ...state,
        isCreateModalOpen: false,
      };
    case types.NEW_DISCOUNT_MODAL_OPEN:
      return {
        ...state,
        isCreateModalOpen: true,
      };
    case types.RECEIVE_DISCOUNT_DEFINITIONS:
      return {
        ...state,
        discountDefIds: payload.result,
      };
    default:
      return state;
  }
};

export default reduceReducers(entitiesReducer, reducer, initialState);

export const getScope = (state) => state.modules.discounts.listPage;

export const getIsCreating = (state) => getScope(state).isCreating;

export const getIsCreateModalOpen = (state) =>
  getScope(state).isCreateModalOpen;

export const getDiscountDefs = (state) => {
  const denormalizedDiscountDefs = denormalize(
    getScope(state).discountDefIds,
    [discountDefSchema],
    getScope(state).entities,
  );
  return sort(createAlphabeticalComparator('name'), denormalizedDiscountDefs);
};

export const isCreating = (state) => getScope(state).isCreating;

export const isCreateModalOpen = (state) => getScope(state).isCreateModalOpen;
